export default function printFontSizePx(fontSizePx: number): string {
    return `${fontSizePx.toFixed(0)}px`;
}
